import axios from 'axios';
import qs from 'query-string';
import JSONP from 'jsonp';
import ExtendableError from 'es6-error';
import { notification } from 'antd';
export class ApiError extends ExtendableError {
  constructor(message = '') {
    super(message);
  }
}

// 空函数
const noop = () => {};

// 解析解析
const { protocol } = window.location;

// TODO
const { CancelToken } = axios;

const createAPI = (host, apiConfig = {}) => {
  
  // request 对象
  function request(endpoint, reqConfig = {}) {
    const config = {
      ...apiConfig,
      ...reqConfig,
    };

    const {
      showNotification = true,
      handleOption,
      handleResp = (resp) => resp.data,
      ...reqOpts
    } = config;

    // 出去多层 // & 拼接协议
    let url = `${host}/${endpoint}`.replace(/\/+/g, '/');
    url = `${protocol}//${url}`;

    let cancel = noop;
    let opts = {
      withCredentials: true,
      cancelToken: new CancelToken((c) => (cancel = c)),
      ...reqOpts,
    };


    if (handleOption) {
      opts = handleOption(opts) || opts;
    }

    const promise = axios(url, opts)
      .then(checkStatus)
      .then((resp) => resp.data)
      .then(chekcResp)
      .then((resp) => handleResp(resp))
      .catch((error) => {
        if (axios.isCancel(error)) {
          console.warn(`请求取消：${endpoint}`);
          return;
        }
        throw error;
      });
    return {
      promise,
      cancel,
    };

    function checkStatus(resp) {
      if (resp.status >= 200 && resp.status < 300) {
        return resp;
      }
      if (showNotification) {
        notification.error({
          message: `请求错误 ${resp.status}: ${resp.config.url}`,
          description: resp.statusText,
        });
      }
      throw new ApiError(`[${resp.status}] 请求错误 ${resp.config.url}`);
    }

    function chekcResp(data) {
      if (data.success) {
        return data;
      }
      if (showNotification) {
        notification.error({
          message: `请求失败 ${data.code}: ${url}`,
          description: data.msg,
        });
      }
      throw new ApiError(`[${data.code}] 请求失败 ${data.msg}`);
    }
  }

  function getJson(endpoint, data = {}, config) {
    return request(endpoint, {
      ...config,
      method: 'get',
      params: data,
    });
  }

  function postJson(endpoint, data = {}, config) {
    return request(endpoint, {
      ...config,
      method: 'post',
      data,
    });
  }

  function postForm(endpoint, data = {}, config) {
    return request(endpoint, {
      ...config,
      method: 'post',
      data: data instanceof FormData ? data : qs.stringify(data),
    });
  }

  function putJson(endpoint, data = {}, config) {
    return request(endpoint, {
      ...config,
      method: 'put',
      data,
    });
  }

  function patchJson(endpoint, data = {}, config) {
    return request(endpoint, {
      ...config,
      method: 'patch',
      data,
    });
  }

  function deleteJson(endpoint, data = {}, config) {
    return request(endpoint, {
      ...config,
      method: 'delete',
      data,
    });
  }

  function jsonp(endpoint, config = {}) {
    const {
      handleResp = (resp) => resp.data,
      showNotification = 'true',
    } = config;
    return new Promise((resolve, reject) => {
      const url = `${protocol}//${host}/${endpoint}`;
      JSONP(
        url,
        {
          prefix: `__${host.replace(/[^\w\d]/g, '')}`,
        },
        (err, resp) => {
          if (err) return reject(err);
          if (!resp.success) {
            if (showNotification) {
              notification.error({
                message: `请求失败 ${resp.code}: ${url}`,
                description: resp.msg,
              });
            }
            return reject(new ApiError(`[${resp.code}] 请求失败 ${resp.msg}`));
          }
          resolve(handleResp(resp));
        }
      );
    });
  }
  return {
    request,
    getJson,
    postJson,
    postForm,
    putJson,
    patchJson,
    deleteJson,
    jsonp,
  };
};
export default createAPI;
